import { TYPES_LIST } from "~/constants/historyTypeConfigs";

const historyMixin = {
  methods: {
    getTypeConfig(item) {
      const typeConfig = TYPES_LIST[item.typeHistoryId]?.[item.typeId];

      if (!typeConfig) {
        console.error(`Missing type configuration for typeId: ${item.typeId}`);
        return null;
      }

      return typeConfig;
    },
    getIsError(item) {
      const typeConfig = this.getTypeConfig(item);
      return typeConfig ? typeConfig.isError ?? false : "";
    },
    getText(item) {
      const typeConfig = this.getTypeConfig(item);
      if (!typeConfig) return "";

      const textParams = item.info;
      let langParams = typeConfig.langTextParams
        ? typeConfig.langTextParams(textParams, this.$t)
        : {};

      if (typeConfig.route) {
        const routeParams = typeConfig.routeParams
          ? typeConfig.routeParams(item)
          : {};
        const hash = typeConfig.hash ? typeConfig.hash(item.entityId) : "";

        langParams.link = this.$router.resolve({
          name: typeConfig.route,
          params: routeParams,
          hash: hash
        }).href;
      }

      return this.$t(typeConfig.langKeyNotificationAction, langParams);
    },

    getColor(item) {
      const typeConfig = this.getTypeConfig(item);
      return typeConfig ? typeConfig.colorClass : null;
    },

    getIcon(item) {
      const typeConfig = this.getTypeConfig(item);
      return typeConfig ? typeConfig.icon : null;
    },

    getTitle(item) {
      const typeConfig = this.getTypeConfig(item);
      if (!typeConfig) return "";

      const langTitleParams = typeConfig.langTitleParams
        ? typeConfig.langTitleParams(item.info)
        : {};

      return this.$t(typeConfig.langKeyNotificationTitle, langTitleParams);
    }
  }
};

export default historyMixin;
